import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker, AutoComplete, Input } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import CondPagtoFrame from './CondPagtoFrame';
import VendaItemForm from './VendaItemForm';
import ItemFotoProduto from './ItemFotoProduto';
import ModalPadraoForm from './ModalPadraoForm';
import { getUsuario } from "../utils/LoginManager";
import { maskTelefone } from '../utils/Masker';
import Colors from "../utils/Colors";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;

export const OPCOES_COMBO_SIT = [
  { key: 'ABE', label: 'ABERTO' },
  { key: 'ESP', label: 'ESPERA' },
  { key: 'APR', label: 'APROVADO' },
  { key: 'FEC', label: 'FECHADO' },
]

export default class OrcamentoForm extends Component {
  state = {
    registro: {
      orc_idf: 0,
      orc_numero: '',
      orc_situacao: { key: 'ABE' },
      orc_vlr_itens: 0,
      orc_desc_itens: 0,
      orc_acres_itens: 0,
      orc_desc_orc: 0,
      orc_acresc_orc: 0,
      orc_vlr_total: 0,
      orc_cliente: { key: '0' },
      orc_data_emissao: moment().format('DD/MM/YYYY'),
      orc_usuario: { key: '0' },
      orc_cond_pagto: { key: '0' },
      orc_descricao: '',
      orc_nome_cliente: '',
      orc_fone: '',
      orc_endereco: '',
      orc_atividade: '',
      orc_obs: '',
      orc_veiculo: 0,
      veic_descricao: '',
    },
    modalProdutoVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,

    activeKey: "dados",
    listaProdutos: [],
    listaCheckList: [],

    codVeiculosSelect: [],
    descVeiculosSelect: [],
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.dados,
        orc_cliente: this.props.registroSelecionado.dados.orc_cliente,
        orc_usuario: this.props.registroSelecionado.dados.orc_usuario,
        orc_cond_pagto: this.props.registroSelecionado.dados.orc_cond_pagto,
        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        listaCheckList: this.props.registroSelecionado.listaCheckList ? this.props.registroSelecionado.listaCheckList : [],
        visualizando: this.props.registroSelecionado.dados.visualizando,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : []);
      });

      if (this.state.usuario.par_checklist_completo) {
        if (!this.props.registroSelecionado.listaCheckList) {
          this.buscaCheckList();
        }
      }

      if (this.props.registroSelecionado.dados.orc_idf) {
        if ((this.state.usuario.par_veiculos_clientes) && (this.state.usuario.par_cliente != this.props.registroSelecionado.dados.orc_cliente)) {
          this.buscaVeiculos(this.props.registroSelecionado.dados.orc_cliente.key);
        }
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }



  onOK = () => {
    if ((!this.state.registro.orc_data_emissao) || (!moment(this.state.registro.orc_data_emissao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.orc_cliente) || (this.state.registro.orc_cliente.key === '0') || (this.state.registro.orc_cliente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((parseInt(this.state.usuario.par_cliente) === parseInt(this.state.registro.orc_cliente.key)) && (this.state.registro.orc_nome_cliente === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome do Cliente', });
      return;
    }
    // if ((parseInt(this.state.usuario.par_cliente) !== parseInt(this.state.registro.orc_cliente.key)) && (this.state.usuario.par_veiculos_clientes) && (this.state.registro.veic_descricao === '')) {
    //   Modal.warning({ title: 'Aviso!', content: 'Informe o Veículo do Cliente', });
    //   return;
    // }
    if ((!this.state.registro.orc_usuario) || (this.state.registro.orc_usuario.key === '0') || (this.state.registro.orc_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }
    if ((!this.state.registro.orc_descricao) || (this.state.registro.orc_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição do Orçamento' });
      return;
    }
    // if ((!this.state.listaProdutos) || (this.state.listaProdutos.length === 0)) {
    //   Modal.warning({ title: 'Aviso!', content: 'Inclua algum Item no Orçamento' });
    //   return;
    // }

    const registro = {
      orc_idf: this.state.registro.orc_idf,
      orc_numero: this.state.registro.orc_numero ? this.state.registro.orc_numero : '0',
      orc_situacao: this.state.registro.orc_situacao.key,
      orc_data_emissao: moment(this.state.registro.orc_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      orc_cliente: this.state.registro.orc_cliente.key,
      pes_nome: this.state.registro.orc_cliente.label,

      orc_descricao: this.state.registro.orc_descricao,
      orc_nome_cliente: this.state.registro.orc_nome_cliente,
      orc_fone: this.state.registro.orc_fone,
      orc_endereco: this.state.registro.orc_endereco,
      orc_atividade: this.state.registro.orc_atividade,
      orc_obs: this.state.registro.orc_obs,

      orc_usuario: this.state.registro.orc_usuario.key,
      orc_cond_pagto: this.state.registro.orc_cond_pagto.key,

      orc_veiculo: this.state.registro.orc_veiculo,
      veic_descricao: this.state.registro.veic_descricao,

      orc_vlr_total: this.state.registro.orc_vlr_total,

      listaProdutos: this.state.listaProdutos,
      listaCheckList: this.state.listaCheckList,
    };


    this.props.onSalvarClick(registro);
  };

  calculoTotalPedido = (listaProdutos) => {
    const { registro } = this.state;
    let vlrServicos = 0;
    let vlrProdutos = 0;
    let vlrAvulsos = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);

      if (listaProdutos[x].tipoItem === 'S') {
        vlrServicos = vlrServicos + parseFloat(listaProdutos[x].mi_vlr_total);
      } else if (listaProdutos[x].tipoItem === 'P') {
        vlrProdutos = vlrProdutos + parseFloat(listaProdutos[x].mi_vlr_total);
      } else if (listaProdutos[x].tipoItem === 'A') {
        vlrAvulsos = vlrAvulsos + parseFloat(listaProdutos[x].mi_vlr_total);
      }
    };

    vlrServicos = parseFloat(vlrServicos.toFixed(2));
    vlrProdutos = parseFloat(vlrProdutos.toFixed(2));
    vlrAvulsos = parseFloat(vlrAvulsos.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.orc_vlr_servicos = vlrServicos;
    registro.orc_vlr_produtos = vlrProdutos;
    registro.orc_vlr_avulsos = vlrAvulsos;
    registro.orc_vlr_total = vlrTotal;

    this.setState({
      registro,
    });
  }

  onChangeCliente = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });

    this.buscaCondPagtos(event.target.value.key);
  };



  onChange = event => {
    // console.log('onChange: ', event);
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    // console.log('onChangePessoa: ', event.orc_cliente);
    const { registro } = this.state;
    registro['orc_cliente'] = event.orc_cliente;
    this.setState(event);
    this.buscaVeiculos(event.orc_cliente.key);
  }


  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['orc_usuario'] = event.orc_usuario;
    this.setState(event);
  }

  onDateEmissaoChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['orc_data_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ orc_data_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }



  buscaVeiculos = (cliente) => {
    // console.log('buscaVeiculos: ', cliente);
    this.setState({ codVeiculosSelect: [], descVeiculosSelect: [] });
    return axios.get('/pessoas/buscaVeiculos', {
      params: {
        pessoa: cliente,
      }
    }).then(response => {
      const { data } = response;
      const codVeiculosSelect = data.map(veic => veic.veic_idf);
      const descVeiculosSelect = data.map(veic => veic.veic_descricao);
      // console.log('buscaVeiculos: ', codVeiculosSelect);
      // console.log('buscaVeiculos: ', descVeiculosSelect);
      this.setState({
        codVeiculosSelect,
        descVeiculosSelect,
      })
    }).catch(error => {
      console.error(error.response);
    })
  }

  onChangeVeiculo = (value) => {
    // console.log('onChangeVeiculo: ', value);
    const { registro } = this.state;
    registro['orc_veiculo'] = 0;
    registro['veic_descricao'] = value;
    this.setState({
      orc_veiculo: 0,
      veic_descricao: value,
    });
  }

  onSelectVeiculo = (value) => {
    // console.log('onSelectVeiculo: ', value);
    const { registro } = this.state;
    const registroIndex = this.state.descVeiculosSelect.findIndex((x) => x === value);
    // console.log('onSelectVeiculo: ', registroIndex);
    // console.log('onSelectVeiculo: ', this.state.codVeiculosSelect[registroIndex]);
    registro['orc_veiculo'] = this.state.codVeiculosSelect[registroIndex];
    registro['veic_descricao'] = value;
    this.setState({
      orc_veiculo: this.state.codVeiculosSelect[registroIndex],
      veic_descricao: value,
    });
  }



  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    },
      this.calculoTotalPedido(listaProdutos)
    );
  }

  onNovoProduto = (event) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: false,
        tipoTela: 'ORC',
        registro: {
          mi_seq: -1,
          mi_item: { key: '0' },
          mi_servico: { key: '0' },
          mi_item_Avulso: '',
          prod_codigo: '',
          prod_descricao: '',
          prod_cod_barras: '',
          mi_qtde: 1,
          osia_custo_unit: 0,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
          mi_calc_estoque: 1,
          tipoItem: 'P',
        }
      }
    });
  }

  onEditarProdutosClick = (reg) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: true,
        tipoTela: 'ORC',
        registro: {
          mi_item: {
            key: String(reg.mi_item) + '_' + String(reg.mi_item_tamanho) + '_' + String(reg.mi_item_cor),
            label: (reg.prod_grade ? (reg.prod_descricao + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.prod_descricao) + ' [' + reg.prod_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),
            prod_grade: reg.prod_grade,
            prod_cod_barras: reg.prod_cod_barras,
            pest_item: reg.mi_item,
            pest_tamanho: reg.mi_item_tamanho,
            pest_cor: reg.mi_item_cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },
          mi_seq: reg.mi_seq,

          mi_servico: {
            key: reg.mi_servico,
            label: reg.prod_descricao,
          },
          mi_item_Avulso: reg.prod_descricao,

          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          prod_cod_barras: reg.prod_cod_barras,
          mi_qtde: reg.mi_qtde,
          osia_custo_unit: reg.osia_custo_unit,
          mi_vlr_unit: reg.mi_vlr_unit,
          mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
          mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
          mi_perc_desc: reg.mi_perc_desc,
          mi_vlr_desc: reg.mi_vlr_desc,
          mi_vlr_total: reg.mi_vlr_total,
          mi_calc_estoque: reg.mi_calc_estoque,

          tipoItem: reg.tipoItem,
        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este Item?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }




  renderValor = (orc_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(orc_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderTipoItem = (tipo) => {
    return (
      <span> {tipo === 'P' ? 'Produto' : (tipo === 'S' ? 'Serviço' : 'Avulso')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['orc_cond_pagto'] = event.orc_cond_pagto;
    this.setState(event);
  }

  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  renderAcoesCheckList = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Conforme">
          <Button type="primary" onClick={() => this.onConformeClick(registro)} icon="like" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
        </Tooltip>
        <Tooltip title="Não Conforme">
          <Button type="danger" onClick={() => this.onNaoConformeClick(registro)} icon="dislike" />
        </Tooltip>
        <Tooltip title="Não se Aplica">
          <Button type="ghost" onClick={() => this.onNaoAplicaClick(registro)} icon="close" />
        </Tooltip>
      </ButtonGroup>
    );
  };

  buscaCheckList = (cliente) => {
    // console.log('buscaCheckList: ');
    this.setState({ listaCheckList: [] });
    return axios.get('/checklist/lista')
      .then(response => {
        // console.log('buscaCheckList: ', response);
        const listaCheckList = response.data.map(regList => {
          return {
            clos_idf: regList.clos_idf,
            clos_descricao: regList.clos_descricao,
            check: '',
            obs: '',
          }
        });
        this.setState({
          listaCheckList,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }

  onConformeClick = (reg) => {
    // console.log('onConformeClick: ', reg);
    const listaCheckList = [...this.state.listaCheckList];
    const index = listaCheckList.findIndex(registro => registro.clos_idf === reg.clos_idf);
    listaCheckList[index] = {
      clos_idf: reg.clos_idf,
      clos_descricao: reg.clos_descricao,
      check: 'CO',
      obs: '',
    };
    this.setState({
      listaCheckList,
    });
  }

  onNaoConformeClick = (reg) => {
    // console.log('onNaoConformeClick: ', reg);
    const listaCheckList = [...this.state.listaCheckList];
    const index = listaCheckList.findIndex(registro => registro.clos_idf === reg.clos_idf);
    listaCheckList[index] = {
      clos_idf: reg.clos_idf,
      clos_descricao: reg.clos_descricao,
      check: 'NC',
      obs: '',
    };
    this.setState({
      listaCheckList,
    });
  }

  onNaoAplicaClick = (reg) => {
    // console.log('onNaoAplicaClick: ', reg);
    const listaCheckList = [...this.state.listaCheckList];
    const index = listaCheckList.findIndex(registro => registro.clos_idf === reg.clos_idf);
    listaCheckList[index] = {
      clos_idf: reg.clos_idf,
      clos_descricao: reg.clos_descricao,
      check: 'NA',
      obs: '',
    };
    this.setState({
      listaCheckList,
    });
  }

  renderCheck = (tipo) => {
    return (
      <span style={{ color: tipo === 'CO' ? '#04B404' : (tipo === 'NC' ? '#FF0000' : '#FFBF00') }}> {tipo === 'CO' ? 'CONFORME' : tipo === 'NC' ? 'NÃO CONFORME' : tipo === 'NA' ? 'NÃO SE APLICA' : ''} </span>
    );
  };

  renderOBS = (obs, registro) => {
    // console.log('renderOBS: ', registro);
    if ((registro.check === 'NC') && (!this.state.registro.orc_idf)) {
      return (
        <Col xs={24} style={{ marginTop: -12, marginBottom: -30, marginLeft: -10, marginRight: -10 }}>
          <Input
            size="small"
            onChange={(value) => {
              // console.log('renderOBS1: ', value.target.value);
              registro['obs'] = value.target.value;
            }}
          />
        </Col>
      )
    } else {
      return (
        <span> {registro.obs} </span>
      )
    }
  };




  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { usuario, carregandoForm, listaProdutos, produtoSelecionado, descVeiculosSelect, listaCheckList,
      modalListaVisible, modalProdutoVisible } = this.state;

    const { orc_idf, orc_numero, orc_situacao, orc_data_emissao, orc_cliente, orc_nome_cliente, orc_fone, orc_endereco, orc_atividade, orc_obs, orc_cond_pagto,
      orc_usuario, orc_descricao, veic_descricao,
      orc_vlr_total, orc_vlr_servicos, orc_vlr_produtos, orc_vlr_avulsos
    } = this.state.registro;

    // console.log('OrcamentoForm.this.state: ', this.state);

    return (
      <Modal
        title={orc_idf ? (this.state.visualizando ? "Orçamento" : "Edição de Orçamento") : "Inclusão de Orçamento"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={'clientes'}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <VendaItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          produtoSelecionado={produtoSelecionado}
        />



        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <Col xs={24} sm={4} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="orc_numero"
                        ref="orc_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={orc_numero}
                        readOnly
                      />
                    </Col>
                    <Col xs={24} sm={8} style={{ marginTop: 4 }} className="camposEspacoDireita">
                      <span>Data Emissão *</span>
                      <DatePicker
                        onChange={this.onDateEmissaoChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(orc_data_emissao, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={12}>
                      <span>Situação *</span>
                      <InputForm
                        type="select"
                        id="orc_situacao"
                        ref="orc_situacao"
                        value={orc_situacao}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChange}
                        data={OPCOES_COMBO_SIT}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={10} style={{ marginTop: -20 }}>
                      <PessoaFrame
                        label="Cliente *"
                        id="orc_cliente"
                        value={orc_cliente}
                        tipo="C"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        descricaoPrimeiroItem="Selecione um Cliente"
                      />
                    </Col>
                    <Col xs={24} sm={2} style={{ marginTop: 4, paddingRight: 20 }}>
                      <Tooltip title="Cadastro de Clientes" placement="topLeft">
                        <Button
                          type="dashed"
                          icon="plus"
                          htmlType="button"
                          onClick={() => this.onCadPessoaClick()}
                        />
                      </Tooltip>
                    </Col>

                    {usuario && usuario.par_veiculos_clientes && parseInt(usuario.par_cliente) === parseInt(orc_cliente.key) ? (
                      <div>
                        <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                          <span>Nome Cliente</span>
                          <InputForm
                            id="orc_nome_cliente"
                            ref="orc_nome_cliente"
                            value={orc_nome_cliente}
                            maxLength={50}
                            onChange={this.onChange}
                            validator={value => Boolean(value)}
                          />
                        </Col>
                        <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                          <span>Telefone Cliente</span>
                          <InputForm
                            id="orc_fone"
                            ref="orc_fone"
                            value={orc_fone}
                            maxLength={15}
                            masker={maskTelefone}
                            onChange={this.onChange}
                            validator={value => Boolean(value)}
                          />
                        </Col>
                        <Col xs={24} sm={18} style={{ marginTop: -20 }}>
                          <span>Endereço Cliente</span>
                          <InputForm
                            id="orc_endereco"
                            ref="orc_endereco"
                            value={orc_endereco}
                            maxLength={100}
                            onChange={this.onChange}
                            validator={value => Boolean(value)}
                          />
                        </Col>
                      </div>
                    ) : (
                      <div>
                        {usuario && usuario.par_veiculos_clientes ? (
                          <Col xs={24} sm={12} style={{ marginTop: -16 }}>
                            <span>Veículo do Cliente</span>
                            <AutoComplete
                              id="veic_descricao"
                              ref="veic_descricao"
                              value={veic_descricao}
                              style={{ width: "100%" }}
                              dataSource={descVeiculosSelect}
                              // placeholder="Placa / Marca / Modelo / Ano / Cor"
                              onSelect={this.onSelectVeiculo}
                              onSearch={this.onChangeVeiculo}
                              // onChange={this.onChange}
                              // onChange={this.onChangeVeiculo}
                              filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                            />
                          </Col>
                        ) : null}
                      </div>
                    )}

                    <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                      <span>Descrição *</span>
                      <InputForm
                        id="orc_descricao"
                        ref="orc_descricao"
                        value={orc_descricao}
                        maxLength={100}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                    {/* <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                      <span>Atividade</span>
                      <InputForm
                        id="orc_atividade"
                        ref="orc_atividade"
                        value={orc_atividade}
                        maxLength={100}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col> */}
                    <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                      <span>Observação</span>
                      <InputForm
                        id="orc_obs"
                        ref="orc_obs"
                        value={orc_obs}
                        maxLength={100}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                    <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                      <UsuarioFrame
                        label="Vendedor *"
                        id="orc_usuario"
                        value={orc_usuario}
                        width={"100%"}
                        vendedor={1}
                        onChange={this.onChangeVendedor}
                        descricaoPrimeiroItem="Selecione um Vendedor"
                      />
                    </Col>
                    <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                      <CondPagtoFrame
                        label="Condição de Pagamento *"
                        id="orc_cond_pagto"
                        value={orc_cond_pagto}
                        width={"100%"}
                        onChange={this.onChangeCondPagto}
                        descricaoPrimeiroItem="Informe a Condição de Pagamento"
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8, paddingRight: 20 }}>
                      <span>Total Serviços</span>
                      <InputForm
                        type="number"
                        id="orc_vlr_servicos"
                        ref="orc_vlr_servicos"
                        value={orc_vlr_servicos}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8, paddingRight: 20 }}>
                      <span>Total Produtos</span>
                      <InputForm
                        type="number"
                        id="orc_vlr_produtos"
                        ref="orc_vlr_produtos"
                        value={orc_vlr_produtos}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8, paddingRight: 20 }}>
                      <span>Total Avulsos</span>
                      <InputForm
                        type="number"
                        id="orc_vlr_avulsos"
                        ref="orc_vlr_avulsos"
                        value={orc_vlr_avulsos}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 8 }}>
                      <span>Total Orçamento</span>
                      <InputForm
                        type="number"
                        id="orc_vlr_total"
                        ref="orc_vlr_total"
                        value={orc_vlr_total}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>

                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Itens do Orçamento" key="produtos">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{ marginTop: -60 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProduto}
                      icon="plus"
                      className="btn-primary"
                    > Novo Item
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  pagination={false}
                  scroll={{ y: 245 }}
                  rowKey={(listaProdutos => listaProdutos.mi_item + '_' + listaProdutos.mi_item_tamanho + '_' + listaProdutos.mi_item_cor)}
                >
                  <Column
                    key="tipoItem"
                    dataIndex="tipoItem"
                    title="Tipo Item"
                    width={60}
                    align="center"
                    className="listaCadastro"
                    render={this.renderTipoItem}
                  />
                  <Column
                    key="foto_produto"
                    title="Foto"
                    width={70}
                    align="center"
                    className="listaCadastro"
                    render={(text, registro) => (
                      <ItemFotoProduto
                        produtoId={registro.prod_idf || registro.mi_item}
                        prodImagem={registro.prod_imagem}
                        prodEmpresa={registro.prod_empresa}
                        tamanho={44}
                        alt={registro.prod_descricao}
                      />
                    )}
                  />
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="mi_qtde"
                    dataIndex="mi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_unit"
                    dataIndex="mi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_desc"
                    dataIndex="mi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_total"
                    dataIndex="mi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  {this.state.visualizando || orc_situacao === 'FEC' ? null : (
                    <Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutos}
                      width={70}
                      align="center"
                      className="listaCadastro"
                    />
                  )}
                </Table>
              </div>
            </TabPane>

            {usuario && usuario.par_checklist_completo ? (
              <TabPane tab="Check-List" key="checklist">
                <div style={{ height: 350 }}>
                  <Table
                    loading={{
                      spinning: carregandoForm,
                      tip: 'Carregando. Aguarde...',
                      size: "large"
                    }}
                    dataSource={listaCheckList}
                    pagination={false}
                    rowKey={(listaCheckList => listaCheckList.clos_idf)}
                    scroll={{ y: 245 }}
                  >
                    <Column
                      key="clos_descricao"
                      dataIndex="clos_descricao"
                      title="Itens do Check List"
                      width={"40%"}
                      align="left"
                      className="listaCadastro"
                    />
                    <Column
                      key="check"
                      dataIndex="check"
                      title="Checagem"
                      width={"15%"}
                      align="center"
                      render={this.renderCheck}
                      className="listaCadastro"
                    />
                    <Column
                      key="obs"
                      dataIndex="obs"
                      title="Observação"
                      width={"20%"}
                      align="left"
                      render={this.renderOBS}
                      className="listaCadastro"
                    />
                    <Column
                      key="acoes"
                      title=""
                      render={this.state.registro.orc_idf ? '' : this.renderAcoesCheckList}
                      width={"25%"}
                      align="center"
                      className="listaCadastro"
                    />
                  </Table>
                </div>
              </TabPane>
            ) : null}

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar || orc_situacao === 'FEC' ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar Orçamento
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrcamentoForm.js